import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { Button, Container, Typography } from "@mui/material";
import { $sidebar } from "store/sidebar";
import { useNavigate } from "react-router-dom";

const PageNotFound = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    $sidebar.setPageTitle("Страница не найдена");
  }, []);

  return (
    <Container
      fixed
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography
        component="div"
        sx={{ fontSize: "6rem", fontWeight: 600, lineHeight: 1 }}
      >
        404
      </Typography>
      <Typography variant="h4" component="div" sx={{ mt: 6, mb: 2 }}>
        Страница не существует
      </Typography>
      <Button variant="contained" onClick={() => navigate("/dashboard")}>
        На главную
      </Button>
    </Container>
  );
});

export default PageNotFound;
